<template>
  <PageTemplate
    page-name="news"
    :datas="datas"
    :nv-items="nvItems"
    ref="page"
    :lang="lang"
    @homeClick="homeClick"
  />
</template>

<script>
import PageTemplate from "@/components/PageTemplate.vue";
import { getNewsGroup } from "@/api/data.js";
let newsData = undefined;
let showContent = false;
export default {
  components: {
    PageTemplate,
  },
  props: ["lang"],
  data() {
    return {
      datas: [],
      activeItem: 0,
      nvItems: [
        {
          name: "首页",
          path: "/",
          enName: "Home",
        },
        {
          name: "动态",
          path: "",
          enName: "News",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    homeClick() {
      this.$emit("toHome");
    },
    cleanNews() {
      newsData = undefined;
      showContent = false;
      // this.$refs.page.setNews(news);
    },
    setActiveItem(news) {
      newsData = news;
      showContent = true;
      this.getData();
      // this.$refs.page.setNews(news);
    },
    menuItemClick(e) {
      this.activeItem = parseInt(e);
    },
    getData() {
      let that = this;
      getNewsGroup()
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            let data = response.data.data;
            that.datas = data;
          } else {
            that.datas = [];
          }
          if (showContent && newsData) {
            showContent = false;
            setTimeout(function () {
              that.$refs.page.setNews(newsData);
              that.$refs.page.updateView("test");
            }, 500);
          }
        })
        .catch((error) => {
          if (newsData && showContent) {
            showContent = false;
            setTimeout(function () {
              that.$refs.page.setNews(newsData);
              that.$refs.page.updateView("test");
            }, 100);
          }
          console.log(error);
          that.datas = [];
        });
    },
  },
};
</script>

<style scoped></style>
